<template>
  <SortSearch default-sort="featured" dimension="FeaturedGraphics" :force-experience="getDesign" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  },
  nuxtI18n: {
    paths: {
      en: '/design/featured-graphics/p/:page',
      es: '/design/graficos-destacados/p/:page',
      pt: '/design/graficos-em-destaque/p/:page',
      de: '/design/hervorgehoben-grafiken/p/:page'
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, follow' }]
    };
  }
};
</script>
